/**
 * Single source for API base URL. Same as login and all other API calls.
 * - On localhost: use backend directly (http://localhost:8000) so no proxy needed.
 * - On production (e.g. config-go.com): use current origin so /api is proxied by the server.
 */
function getApiUrl() {
  if (typeof window === 'undefined' || !window.location) {
    const envUrl = process.env.REACT_APP_API_URL;
    if (typeof envUrl === 'string' && envUrl.trim() !== '') {
      return envUrl.trim().replace(/\/$/, '');
    }
    return '';
  }
  const origin = window.location.origin;
  const hostname = window.location.hostname || '';
  // Local dev: talk to backend on port 8000 directly (avoids proxy issues)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000';
  }
  // Production: same origin (e.g. https://config-go.com), server proxies /api to backend
  return origin;
}

export const API_URL = getApiUrl();
